import { LANGUAGES } from "../../../../../config/languages";

export const LANGUAGE_PARAMS = {
  [LANGUAGES.spanish]: {
    alpha_3: "esp",
    label: "Español",
    region: "es",
  },
  [LANGUAGES.catalan]: {
    alpha_3: "cat",
    label: "Català",
    region: "es",
  },
  [LANGUAGES.english]: {
    alpha_3: "gbr",
    label: "English",
    region: "us",
  },
};
